import {useState} from 'react';
import ArrRadio from '../../../components/common/arr-radio/ArrRadio';

const options = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
];
const RadioDemo = () => {
  const [selected, setSelected] = useState('');
  return (
    <>
      <ArrRadio
        dataTestId="controlled-radio-buttons-group-1"
        selected={true}
        name="controlled-radio-buttons-group"
        onChange={(value) => {
          setSelected(value);
        }}
        value={selected}
        data={options}
      />
      <ArrRadio
        dataTestId="controlled-radio-buttons-group-2"
        selected={true}
        name="controlled-radio-buttons-group"
        onChange={(value) => {
          setSelected(value);
        }}
        value={selected}
        data={options}
        size="medium"
      />
      <ArrRadio
        dataTestId="controlled-radio-buttons-group-3"
        selected={true}
        name="controlled-radio-buttons-group"
        size="small"
        onChange={(value) => {
          setSelected(value);
        }}
        value={selected}
        data={options}
      />
      <ArrRadio
        dataTestId="controlled-radio-buttons-group-4"
        selected={true}
        name="controlled-radio-buttons-group"
        size="xs"
        onChange={(value) => {
          setSelected(value);
        }}
        value={selected}
        data={options}
      />
    </>
  );
};

export default RadioDemo;
